// Canvas order is bottom to top; the layer list presents top to bottom.
export function groupedLayers(shapes) {
  const ids = new Set(shapes.map((shape) => shape.id));
  return shapes
    .filter((shape) => !shape.parentId || !ids.has(shape.parentId))
    .map((shape) => ({
      shape,
      effects: shapes.filter((effect) => effect.parentId === shape.id)
    }));
}

export function flattenLayers(groups) {
  return groups.flatMap(({ shape, effects }) => [...effects, shape]);
}
